<template>
    <div v-if="authenticated">
        <v-layout row align-center justify-start>
        <div  class="dLabel">Date range</div>
        <div>
        <v-icon class="dArrow">trending_flat</v-icon>
        </div>
        <div>
        <v-dialog v-model="dialog1" persistent max-width="700px">
            <v-btn class="dSelect" slot="activator" small round light>{{ range[0] }}</v-btn>
            <v-card max-width="700px">
            <v-card-title>
                <span class="headline">Date Range Selection</span>
            </v-card-title>
            <v-card-text>
                <div>
                <v-daterange :options="dateRangeOptions" no-presets @input="onDateRangeChange"/>
                </div>
            </v-card-text>
            <v-card-actions>
                <v-btn flat @click="$emit('window-closed');dialog1=false" round>Done</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
    <div>
        <v-icon class="dArrow">trending_flat</v-icon>
    </div>
    <div>
        <v-dialog v-model="dialog2" persistent max-width="700px">
        <v-btn class="dSelect" slot="activator" small round light>{{ range[1] }}</v-btn>
        <v-card max-width="700px">
            <v-card-title>
            <span class="headline">Date Range Selection</span>
            </v-card-title>
            <v-card-text>
            <div>
                <v-daterange :options="dateRangeOptions" no-presets @input="onDateRangeChange"/>
            </div>
            </v-card-text>
            <v-card-actions>
            <v-btn flat @click="$emit('window-closed');dialog2=false" round>Done</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </div>
    </v-layout>
    </div>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'
import { format } from 'date-fns'

  export default {
      data() {
        return {
            dialog1: false,
            dialog2: false,
            dateRangeOptions: {
                startDate: format(new Date(), 'YYYY-MM-DD'),
                endDate: format(new Date(), 'YYYY-MM-DD'),
                format: 'YYYY-MM-DD'
            }
        }
    },
    methods: {
        onDateRangeChange(range) {
            this.setRange(range)
        },
        ...mapMutations([
            'setRange'
        ]),
        ...mapGetters([
            'getRange'
        ]),
        setDefaultRange() {
          if ( this.getRange()[0] == null ) {
              this.setRange( [format(new Date(), 'YYYY-MM-DD'), format(new Date(), 'YYYY-MM-DD')] ); 
          }
        }
      },
      computed: {
        ...mapState([
            'authenticated',
            'range'
        ])
    },
    mounted() {
        this.setDefaultRange();
    }
  }
</script>

<style scoped>
.dLabel {
    min-width: 75px
}
.dSelect {
    min-width: 100px
}
.dArrow {
    min-width: 20px;
    font-size: 16px
}
</style>
